export const channel = {
  'GANAMOVIL(PERSONAS)': 'GanaMóvil',
  GANANET: 'Gananet',
  'BILLETERA MOVIL': 'Billetera',
  Billetera: 'Billetera',
} as const;

export const conciliationChannels = {
  WALLET: 'Billetera',
  GANA_MOVIL: 'GanaMóvil',
  GANANET: 'Gananet',
} as const;
